export default __webpack_public_path__ + "static/youbloom-02434c2edb9dc1808a30bcd2a41a2145.webp";